import React from 'react';
import { Card, Space, Spin, Select, Table, Tooltip } from 'antd';
import cnnaid from '../../../../../../../assets/icons/transactions/cnnaid.png';
import cnnaip from '../../../../../../../assets/icons/transactions/cnnaip.png';
import cnnafingerprint from '../../../../../../../assets/icons/transactions/cnnafingerprint.png';
import { ReactComponent as GlobePhoneIcon } from '../../../../../../../assets/icons/transactions/globephone.svg';
import moment from 'moment';
import TopBar from './TopBar';
import SignUpsV2Chart from './SignUpsV2Chart';
import SignupImpressions from './SignupImpressions';
import { attributionWindowSelections } from '../../../../../../../core/utils/constants/constants';

const SignUpsV2Layout = ({
  signupsData,
  signupsLoading,
  signupsByDateData,
  chartLoading,
  onDateRangeChange,
  onAttrMethodChange,
  onAttrWindowChange = () => {},
  onPageChange,
  onPageSizeChange,
  currentPage,
  pageSize,
  dateRange,
  attrMethod,
  attrWindow,
  campaignOrder,
}) => {
  // Columns for signups table
  const columns = [
    {
      title: 'Sign Up Id',
      dataIndex: 'signUpId',
      key: 'signUpId',
      width: 150,
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Last Impression',
      dataIndex: 'lastImpression',
      key: 'lastImpression',
      width: 150,
      render: (date) => date ? moment(date).format('MM/DD/YY HH:mm') : 'N/A',
    },
    {
      title: 'Impressions',
      dataIndex: 'totalImpressions',
      key: 'totalImpressions',
      width: 120,
      render: (count) => <span>{count}</span>,
    },
    {
      title: 'Signed up on',
      dataIndex: 'signUpDate',
      key: 'signUpDate',
      width: 150,
      render: (date) => moment(date).format('MM/DD/YY HH:mm'),
    },
    {
      title: '',
      dataIndex: 'attrMethod',
      key: 'attrIcon',
      width: 50,
      render: (method) => {
        let attributionIcon = cnnaip;
        let tip = '';

        if (method === 'COOKIES') {
          attributionIcon = cnnaid;
          tip = 'Cookie Match - Deterministic match using browser based cookie / uuid match.';
        } else if (method === 'FINGERPRINT') {
          attributionIcon = cnnafingerprint;
          tip = 'User Match - Probabilistic match using user fingerprint.';
        } else if (method === 'DEVICE_FINGERPRINT') {
          return (
            <Tooltip title="Device Match - Probabilistic match using user device model information">
              <span role="img" className="anticon" style={{ verticalAlign: '-5px' }}>
                <GlobePhoneIcon height="35" width="35" style={{ opacity: '1.0' }} />
              </span>
            </Tooltip>
          );
        } else if (method === 'IP') {
          tip = 'IP Match - Probabilistic match using IP address.';
          attributionIcon = cnnaip;
        }

        return (
          <Tooltip title={tip}>
            <img src={attributionIcon} alt={method} style={{ height: 35, width: 35 }} />
          </Tooltip>
        );
      },
    },
  ];

  // Calculate total signups from actual paginated data to reflect filters
  // Use signupsData.total which includes all filtered results (date range, attribution method/window)
  const totalSignups = signupsData?.total || 0;

  return (
    <div>
      {/* Top Bar with Flight Dates and Total Signups */}
      <TopBar
        startDate={campaignOrder?.startDate}
        endDate={campaignOrder?.endDate}
        totalSignups={totalSignups}
      />

      {/* Chart by Date with Date Filter */}
      <SignUpsV2Chart
        data={signupsByDateData || []}
        loading={chartLoading}
        dateRange={dateRange}
        onDateRangeChange={onDateRangeChange}
        campaignOrder={campaignOrder}
      />

      {/* Table with Filters */}
      <Card
        style={{ marginTop: 16 }}
        title={<span style={{ fontSize: '16px', fontWeight: 'bold' }}>Sign Ups</span>}
        extra={
          <Space style={{ gap: '16px' }}>
            <span>Attribution Method</span>
            <Select
              style={{ width: 150 }}
              placeholder="Select method"
              onChange={(value) => {
                onAttrMethodChange(value);
              }}
              allowClear
              value={attrMethod}
              options={[
                { label: 'Cookie', value: 'COOKIES' },
                { label: 'Fingerprint', value: 'FINGERPRINT' },
                { label: 'Device Fingerprint', value: 'DEVICE_FINGERPRINT' },
                { label: 'IP Address', value: 'IP' },
              ]}
            />
            <span>Attribution Window</span>
            <Select
              value={attrWindow}
              placeholder="Please select days"
              style={{ width: 120 }}
              onChange={(value) => {
                onAttrWindowChange(value);
              }}
              options={attributionWindowSelections.map((option) => ({
                label: option.name,
                value: option.key,
              }))}
            />
          </Space>
        }
      >
        <Space direction="vertical" style={{ width: '100%' }} size="large">
        {/* Signups Table */}
        <Spin spinning={signupsLoading}>
          <Table
            columns={columns}
            dataSource={signupsData?.signups || []}
            rowKey="id"
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: signupsData?.total || 0,
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              onChange: (page, size) => {
                onPageChange(page, size);
              },
              onShowSizeChange: (current, size) => {
                onPageSizeChange(current, size);
              },
            }}
            expandable={{
              expandedRowRender: (record) => (
                <SignupImpressions signupId={record.id} />
              ),
            }}
          />
        </Spin>
        </Space>
      </Card>
    </div>
  );
};

export default SignUpsV2Layout;
